import './asset.css';
import listIcon from './list.png';
export const Asset = () => {
  return (
    <div id="asset">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-6" data-aos="fade-left">
            <div className="asset-text">
              <h2>The Asset</h2>
              <ul>
                <li>
                  <img src={listIcon} className="list-icon" alt="list icon"/>
                  Natural Corundum Ruby in Zoisite Matrix - by GIA (Gemological Institute of America)
                </li>
                <li>
                  <img src={listIcon} className="list-icon" alt="list icon"/>
                  Extracted from a ruby mine in Arusha region in north-eastern Tanzania
                  </li>
                <li>
                  <img src={listIcon} className="list-icon" alt="list icon"/>
                  Arusha region is source for some of the world’s finest gemstones  
                </li>
                <li>
                  <img src={listIcon} className="list-icon" alt="list icon"/>
                  32,700 carats, 6.54-kilogram - Ruby Specimen 
                </li>
                <li>
                  <img src={listIcon} className="list-icon" alt="list icon"/>
                  Appraisal value of $261,600,000
                </li>
                <li>
                  <img src={listIcon} className="list-icon" alt="list icon"/>
                  The Specimen with all its documents are safely stored in Ferrari Group in Geneva, Switzerland; a world-class safety house for luxury jewelry and goods
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-6" data-aos="fade-right">
            {" "}
            <img src="../../img/asset.png" className="img-responsive" alt="" width="280px" loading="lazy"/>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};
